<template>
  <div>
    <!--    <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="数据" name="data">  <router-view /></el-tab-pane>
          <el-tab-pane label="进度" name="query">  <router-view /></el-tab-pane>
          <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
          <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
        </el-tabs>-->
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"  background-color="#545c64"
             text-color="#fff"
             active-text-color="#ffd04b" :router="true" >
      <el-menu-item index="query"><i class="el-icon-data-analysis"></i>添加分析条件</el-menu-item>
      <el-menu-item index="crossQuery"><i class="el-icon-guide"></i>添加交叉分析条件</el-menu-item>
      <el-menu-item index="data"><i class="el-icon-s-data"></i>数据表</el-menu-item>
<!--      <el-submenu index="2">
        <template slot="title">我的工作台</template>
        <el-menu-item index="2-1">选项1</el-menu-item>
        <el-menu-item index="2-2">选项2</el-menu-item>
        <el-menu-item index="2-3">选项3</el-menu-item>
        <el-submenu index="2-4">
          <template slot="title">选项4</template>
          <el-menu-item index="2-4-1">选项1</el-menu-item>
          <el-menu-item index="2-4-2">选项2</el-menu-item>
          <el-menu-item index="2-4-3">选项3</el-menu-item>
        </el-submenu>
      </el-submenu>
      <el-menu-item index="3" disabled>消息中心</el-menu-item>
      <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item>-->
    </el-menu>
<!--
    <el-breadcrumb separator=">">
      <el-breadcrumb-item :to="{ path: '/report/dp/'+$route.params.id+'/data' }">数据</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/report/dp/'+$route.params.id+'/query' }">进度</el-breadcrumb-item>
    </el-breadcrumb>-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "dp-router",
  data() {
    return {
      activeIndex: 'query',
    /*  list:[
        {
          url:'/report/dp/',
          icon:'data',
          label:'数据'
        },
        {
          url:'/report/dp/',
          icon:'data',
          label:'进度'
        },
      ]*/
    };
  },
  methods: {
  },
  created() {
    console.log(this.$route.name,'this.$route.name')
    if(this.$route.name === 'dp-query'){
      this.activeIndex = 'query'
    }else if(this.$route.name == 'dp-crossQuery'){
      this.activeIndex = 'crossQuery'
    }

    // this.handleClick();
    // this.$router.push({path:'/report/dp/'+this.$route.params.id+'/data'})
  },
/*  watch:{
   "$route.name"
  }*/
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/qms/dp-router/index.vue